<template>
	<div ref="mallLayoutRef" class="mall-layout">
		<!-- 顶部导航 -->
		<MallHeader :navItems="navItems" />

		<!-- 主内容区 -->
		<main class="mall-main">
			<slot />
		</main>

		<!-- 页脚 -->
		<MallFooter :navItems="navItems" />
	</div>
</template>

<script setup lang="ts">
import { watch, ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import MallHeader from './components/MallHeader.vue'
import MallFooter from './components/MallFooter.vue'
import { getCategoryTree } from '@/api/mall/category'
import type { Category } from '@/views/mall/types'
import useStore from '@/store'

const route = useRoute()
const mallLayoutRef = ref<HTMLElement>()
const { userStore } = useStore()

// 路由切换时滚动到顶部
watch(
	() => route.fullPath,
	() => {
		nextTick(() => {
			mallLayoutRef.value?.scrollTo(0, 0)
		})
	}
)

onMounted(() => {
	mallLayoutRef.value?.scrollTo(0, 0)
	getCategory()
	userStore.loadProductStockConfig()
})

// 导航项
interface NavItem {
	id: string
	name: { value: string }
	path: string
	child?: Category[]
	langKey?: string
}

const navItems = ref<NavItem[]>([])

const getCategory = async () => {
	const res: any = await getCategoryTree({ parentId: 0 })
	if (res.code === 200) {
		let list = res.data || []
		if (list.length > 5) {
			list.length = 5
		}
		list = list.map((item: any) => {
			item.path = '/mall/category/'
			return item
		})
		list.push({ id: null, name: { value: '' }, path: '/mall/about', child: [], langKey: 'uChoicePc.aboutUs' })
		navItems.value = list
	}
}
</script>

<style lang="scss">
.mall-layout {
	min-width: 1440px;
	height: 100vh;
	overflow: scroll;
	display: flex;
	flex-direction: column;
	/* Chrome、Edge、Safari */
	&::-webkit-scrollbar {
		display: none;
	}

	/* Firefox */
	scrollbar-width: none;
	/* IE 旧版 */
	-ms-overflow-style: none;

	.mall-main {
		flex: 1;
	}
}
</style>
